export function iconContract({ className } = {}) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 60 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10 66.6667C7.22222 66.6667 4.86111 65.6944 2.91667 63.75C0.972222 61.8056 0 59.4444 0 56.6667V46.6667H10V0H60V56.6667C60 59.4444 59.0278 61.8056 57.0833 63.75C55.1389 65.6944 52.7778 66.6667 50 66.6667H10ZM50 60C50.9444 60 51.7361 59.6806 52.375 59.0417C53.0139 58.4028 53.3333 57.6111 53.3333 56.6667V6.66667H16.6667V46.6667H46.6667V56.6667C46.6667 57.6111 46.9861 58.4028 47.625 59.0417C48.2639 59.6806 49.0556 60 50 60ZM20 23.3333V16.6667H50V23.3333H20ZM20 33.3333V26.6667H50V33.3333H20ZM10 60H40V53.3333H6.66667V56.6667C6.66667 57.6111 6.98611 58.4028 7.625 59.0417C8.26389 59.6806 9.05556 60 10 60ZM10 60H6.66667H40H10Z"
        fill="#2F80ED"
      />
    </svg>
  );
}
